import { skincareTips } from '../../../mocks/products';

const SkincareSection = () => {
  return (
    <section id="cuidado" className="py-24 bg-gradient-to-b from-white to-[#FAF8F5]">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-20">
          <div className="inline-block px-6 py-2 border border-gray-300 rounded-full mb-6">
            <span className="text-gray-700 text-sm font-light">Cuidado de la Piel</span>
          </div>
          <h2 className="font-['Playfair_Display'] text-5xl lg:text-6xl font-bold text-gray-900 mb-6">
            Sérums La Roche-Posay<br />Para Cada Necesidad
          </h2>
          <p className="text-gray-600 text-lg font-light max-w-2xl mx-auto">
            Descubrí la línea completa de sérums de La Roche-Posay, formulados con ingredientes activos de alta concentración para transformar tu piel.
          </p>
        </div>

        {/* Grid unificado: 2 columnas en móvil, 3 en desktop */}
        <div className="grid grid-cols-2 lg:grid-cols-3 gap-4 lg:gap-8">
          {skincareTips.map((tip) => (
            <div
              key={tip.id}
              className="bg-[#f5f5f3] rounded-2xl p-5 lg:p-7 hover:shadow-md hover:scale-[1.02] transition-all duration-300 cursor-pointer border border-gray-100"
            >
              <div className="flex items-center justify-between mb-4 lg:mb-5">
                <div className="w-9 h-9 lg:w-11 lg:h-11 flex items-center justify-center bg-white rounded-full shadow-sm">
                  <i className={`${tip.icon} text-base lg:text-xl text-gray-700`}></i>
                </div>
                <span className="px-2 lg:px-3 py-1 bg-white text-gray-600 text-[10px] lg:text-xs rounded-full font-light border border-gray-200 whitespace-nowrap">
                  {tip.badge}
                </span>
              </div>
              <h3 className="text-sm lg:text-lg font-semibold text-gray-900 mb-2 leading-tight">
                {tip.title}
              </h3>
              <p className="text-gray-500 text-xs lg:text-sm font-light leading-relaxed">
                {tip.description}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-20 bg-white rounded-3xl p-12 shadow-sm">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h3 className="font-['Playfair_Display'] text-4xl font-bold text-gray-900 mb-6">
                Productos para Cada Tipo de Piel
              </h3>
              <p className="text-gray-600 text-base font-light leading-relaxed mb-6">
                Cada piel es única. Por eso importamos una amplia variedad de productos de La Roche-Posay y otras marcas líderes, formulados específicamente para piel normal, seca, grasa, mixta y sensible.
              </p>
              <p className="text-gray-600 text-base font-light leading-relaxed mb-8">
                Nuestros productos cuentan con <strong className="font-semibold text-gray-900">aprobación dermatológica y/o clínica</strong>, garantizando eficacia y seguridad comprobada para el cuidado diario de tu piel en el clima de Costa Rica.
              </p>
              <div className="flex flex-wrap gap-3">
                {['Piel Seca', 'Piel Grasa', 'Piel Sensible', 'Piel Mixta', 'Anti-Edad', 'Anti-Acné'].map((tipo) => (
                  <span key={tipo} className="px-4 py-2 bg-[#FAF8F5] text-gray-700 text-sm rounded-full font-light">
                    {tipo}
                  </span>
                ))}
              </div>
            </div>
            <div className="relative">
              <img
                src="https://readdy.ai/api/search-image?query=elegant%20arrangement%20of%20La%20Roche-Posay%20luxury%20skincare%20serums%20and%20moisturizers%20on%20clean%20white%20marble%20surface%20with%20soft%20warm%20natural%20lighting%2C%20professional%20beauty%20photography%20featuring%20premium%20imported%20cosmetics%20with%20minimalist%20aesthetic%20and%20subtle%20botanical%20elements&width=600&height=600&seq=skincare2cr&orientation=squarish"
                alt="Productos de skincare importados"
                className="w-full h-96 object-cover rounded-3xl"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SkincareSection;
